import { ToggleSwitch } from "@nova/component-toggle-switch"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { selectActiveWorkspaceId } from "features/data-management/workspace/WorkspaceManagementSlice"
import { useSpidertracksIntegration } from "features/map/layers/aircraft-tracking/useSpidertracksIntegration"
import { selectSpidertracksEnabled, setSpidertracksEnabled } from "../slice"

export const SpidertracksSection = () => {
    const dispatch = useAppDispatch()
    const orgId = useAppSelector(selectActiveWorkspaceId())
    const spidertracksEnabled = useAppSelector(selectSpidertracksEnabled)
    const { email } = useSpidertracksIntegration(orgId)

    if (!email) return null

    return (
        <>
            <div className="w-full h-px bg-gray-700" />
            <div className="flex flex-col">
                <div
                    className="px-4 py-[14px] flex items-center justify-between cursor-pointer hover:bg-white-100"
                    onClick={() => dispatch(setSpidertracksEnabled(!spidertracksEnabled))}
                >
                    <div className="telegraf">Fleet Manager</div>
                    <ToggleSwitch isToggled={spidertracksEnabled} setIsToggled={() => {}} />
                </div>
            </div>
        </>
    )
}
